<template>
    <table class="table table-bordered table-sm sm-price-table mb-0">
        <thead>
            <tr class="table-hinnad text-center">
                <th class="table-font" scope="col" v-for="(price, jn) in pricelist" :key="jn">
                    {{ price.range.min === 0 ? price.range.min + 1 : price.range.min }}-{{ price.range.max | valueOrDots }} {{ $t('days') }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr class="text-center">
                <th v-for="(price, j) in pricelist" :key="j" class="table-font">
                    <template v-if="price.discount_price && discountPricesExpired()">
                        <span style="text-decoration: line-through">
                            {{ price.price / 100 }} <small>EUR/{{ $t('day') }}</small><br>
                        </span>
                        <span class="text-danger">
                            {{ price.discount_price / 100 }} <small>EUR/{{ $t('day') }}</small>
                        </span>
                    </template>
                    <template v-else>
                        {{ price.price / 100 }} <small>EUR/{{ $t('day') }}</small>
                    </template>
                </th>
            </tr>
        </tbody>
        <tfoot v-if="hasDiscountDates()">
            <tr>
                <th :colspan="pricelist.length" class="text-danger pt-0">
                    <small>{{ $t('Discount rates are valid from') }} {{ vehicle.discount_start_at | formatDate }} - {{ vehicle.discount_end_at | formatDate }}</small>
                </th>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import moment from 'moment';

export default {
    name: 'PricelistTable',
    props: {
        pricelist: Array,
        vehicle: Object
    },
    methods: {
        hasDiscountDates() {
            let hasDiscountPrices = false;
            this.vehicle.prices.map(price => {
                if (price.discount_price) {
                    hasDiscountPrices = true;
                }
            });

            let showDiscountDates = false;
            if (hasDiscountPrices && this.vehicle.discount_start_at && this.vehicle.discount_end_at && moment(this.vehicle.discount_end_at).isAfter(moment())) {
                showDiscountDates = true;
            }

            return showDiscountDates;
        },
        discountPricesExpired() {
            let isExpired = false;
            if (this.vehicle.discount_end_at == null) {
                return true;
            }
            if (moment(this.vehicle.discount_end_at).isAfter(moment())) {
                isExpired = true;
            }

            return isExpired;
        }
    }
};
</script>
